var _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDigicheckLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: 55,
  width: 397.701,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M197.488 55h-2V0h2z",
  fill: "#4a4e52"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#c00000"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.477 39.148A11 11 0 0 1 10.4 28.224a11 11 0 0 1 11.077-10.923 11.135 11.135 0 0 1 5.869 1.658l-5.869 9.265 11.05-6.293a14.824 14.824 0 0 0-5.009-4.748 20.822 20.822 0 0 0-10.403-2.53c-5.815 0-10.915 2.08-13.759 5.2A12.375 12.375 0 0 0 0 28.224a12.374 12.374 0 0 0 3.356 8.37c2.852 3.128 7.875 5.2 13.591 5.2s10.737-2.075 13.591-5.2q.234-.257.454-.522l-.433-1.594a11.107 11.107 0 0 1-9.082 4.67M58.106 41.134l-4.635-17.063a6.532 6.532 0 0 0-6.321-4.784 6.611 6.611 0 0 0-2.239.388l-9.983 3.584h10.264l1.756 6.462a9.766 9.766 0 0 0-6.346-2.325c-4.819 0-8.725 3.186-8.725 7.117s3.906 7.116 8.725 7.116a10.433 10.433 0 0 0 8.427-4.246l1.018 3.75zm-14.144-2.649a3.972 3.972 0 1 1 4.03-3.971 4 4 0 0 1-4.027 3.972M77.017 19.287a4.052 4.052 0 0 0-1.7.372l-6.407 2.947a4.011 4.011 0 0 0-3.972-3.319 4.052 4.052 0 0 0-1.7.372l-7.827 3.6h5.5v17.874h8.054V25.248a2.014 2.014 0 0 1 4.027 0v15.885h8.053V23.259a4 4 0 0 0-4.027-3.972M127.522 19.287a4.055 4.055 0 0 0-1.7.372l-6.407 2.947a4.012 4.012 0 0 0-3.972-3.319 4.057 4.057 0 0 0-1.7.372l-7.827 3.6h5.5v17.874h8.054V25.248a2.014 2.014 0 0 1 4.027 0v15.885h8.053V23.259a4 4 0 0 0-4.027-3.972"
}), /*#__PURE__*/React.createElement("path", {
  d: "M107.219 30.541a11.411 11.411 0 1 1-11.41-11.254 11.333 11.333 0 0 1 11.41 11.254m-10.933-7.836a2.521 2.521 0 0 0-3.083-1.757 2.479 2.479 0 0 0-1.78 3.041l3.908 14.388a2.52 2.52 0 0 0 3.083 1.756 2.479 2.479 0 0 0 1.78-3.041z"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  fontFamily: "Tungsten A, Tungsten B",
  fontSize: 46,
  fontWeight: 600
}, /*#__PURE__*/React.createElement("text", {
  fill: "#c00000",
  transform: "translate(262.43 44)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "Digi")), /*#__PURE__*/React.createElement("text", {
  transform: "translate(309.701 44)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  xmlSpace: "preserve",
  y: 0
}, " CHECK")))));
export default SvgDigicheckLogo;